
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buying-with",
      function () {
        return require("private-next-pages/buying-with.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buying-with"])
      });
    }
  